<template>
  <div class="refundList">
    <FilterForm :fields="searchFields"/>
    <BasicTable
      hiddenFooter
      showSelect
      border
      hasOperate
      customClass="table"
      :tableData="tableData"
      :treeProps="{ children: 'sub', hasChildren: 'hasChildren' }"
      :columns="columns" >
      <template slot="tableOpeate">
        退款退货订单&emsp;
      </template>
    </BasicTable>
  </div>
</template>

<script>
  export default {
    name: 'refundList',
    data() {
      return {
        tableData: [],
        columns: [],
        searchFields: [],
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>